import React from "react";

const SeraloginOnlineCard = ({
  label,
  value,
  bgColor = "#f0f0f0",
  labelColor = "#333333",
  valueColor = "#000000",
  width
}) => {
  const cardStyle = {
    backgroundColor: bgColor,
    padding: "12px 16px",
    borderRadius: "12px",
    textAlign: "center",
    width: width ? width : "100%",
    // margin: "8px"
  };

  const labelStyle = {
    color: labelColor,
    fontWeight: "600",
    fontSize: "14px",
    marginBottom: "4px"
  };

  const valueStyle = {
    color: valueColor,
    fontWeight: "700",
    fontSize: "18px"
  };

  return (
    <div style={cardStyle}>
      <div style={labelStyle}>{label}</div>
      <div style={valueStyle}>{value}</div>
    </div>
  );
};

export default SeraloginOnlineCard;
